/* tslint:disable */

declare var Object: any;
export interface TeodsurveyquestInterface {
  "surveyCode": string;
  "libCode": string;
  "companyCode": string;
  "parentCode": string;
  "iscat": string;
  "parentPath": string;
  "depth": number;
  "libNameEn": string;
  "libNameId": string;
  "libNameMy": string;
  "libNameTh": string;
  "answerType"?: string;
  "statementType"?: string;
  "questOrder"?: number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  rel_option?: any[];
}

export class Teodsurveyquest implements TeodsurveyquestInterface {
  "surveyCode": string;
  "libCode": string;
  "companyCode": string;
  "parentCode": string;
  "iscat": string;
  "parentPath": string;
  "depth": number;
  "libNameEn": string;
  "libNameId": string;
  "libNameMy": string;
  "libNameTh": string;
  "answerType": string;
  "statementType": string;
  "questOrder": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  rel_option: any[];
  constructor(data?: TeodsurveyquestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodsurveyquest`.
   */
  public static getModelName() {
    return "Teodsurveyquest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodsurveyquest for dynamic purposes.
  **/
  public static factory(data: TeodsurveyquestInterface): Teodsurveyquest{
    return new Teodsurveyquest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodsurveyquest',
      plural: 'Teodsurveyquests',
      path: 'Teodsurveyquests',
      properties: {
        "surveyCode": {
          name: 'surveyCode',
          type: 'string'
        },
        "libCode": {
          name: 'libCode',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "parentCode": {
          name: 'parentCode',
          type: 'string'
        },
        "iscat": {
          name: 'iscat',
          type: 'string'
        },
        "parentPath": {
          name: 'parentPath',
          type: 'string'
        },
        "depth": {
          name: 'depth',
          type: 'number'
        },
        "libNameEn": {
          name: 'libNameEn',
          type: 'string'
        },
        "libNameId": {
          name: 'libNameId',
          type: 'string'
        },
        "libNameMy": {
          name: 'libNameMy',
          type: 'string'
        },
        "libNameTh": {
          name: 'libNameTh',
          type: 'string'
        },
        "answerType": {
          name: 'answerType',
          type: 'string'
        },
        "statementType": {
          name: 'statementType',
          type: 'string'
        },
        "questOrder": {
          name: 'questOrder',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
        rel_option: {
          name: 'rel_option',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodsurveyquest.ts